import { api } from '@/api'
import type { SettingsData } from '@/api/typings/general.typing'
import type { ApiResponse } from '@/api/typings/response.typing'

export function getGeneralAction(): Promise<ApiResponse<SettingsData>> {
  return api.get<ApiResponse<SettingsData>>('/settings')
}
